<app-topbar></app-topbar>
<div class="container mr-top-40">
    <h1 class="mainhdng mr-bttm-30">Notifications</h1>
</div>

<div class="container cntremptyscrn">
    <div class="row h-80 justify-content-center align-items-center">
        <div class="common noproductsdiv text-center">
            <img src="assets/images/notifications.png" class="noprdctimg">
            <h3 class="noprdcrthdng">You don’t have notifications to see yet</h3>
            <p class="noprdcrt_subhdng">Click below to start selecting a plan</p>
            <button class="getstrtd noinfobttn" routerLink="/dashboard">Get Started</button>
        </div>
    </div>
</div>